jQuery(document).ready(function ($) {

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//UNIDADES
	$('.lista-estados a').click(function(e) {
		e.preventDefault();
		var estado = $(this).data('estado');
		$('.lista-estados a').attr('class', 'btn btn-outline-primary px-4 fontBold mx-1');
		$(this).toggleClass('btn-primary btn-outline-primary');

		if(estado=='todos') {
			$('.unidades-estado').show();

			return;
		}

		$('.unidades-estado').hide();
		$('.unidades-estado.estado-'+estado).show();

	})

	//BALAO DO WHATS
	$('a.whats').click(function(e) {
		closeWhatsBallon();
	});

	$('.whats-balao').hover(function(e) {
		closeWhatsBallon();
	});

	function closeWhatsBallon() {
		$('.whats-balao').remove();
	}

	setTimeout( function() { closeWhatsBallon(); }, 10000);

	//GALERIA
	$('.galeria-page a, a.galeria-campo').magnificPopup({
		type: 'image',
		gallery:{
			enabled:true,
			tPrev: 'Anterior',
			tNext: 'Próxima',
			tCounter: '%curr% de %total%'
		}
	});

	//CARROSSEIS
	$('.destaques-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

	$('.parceiros-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:6000,
		dots:true,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:false,
		autoHeight: false,
		responsive:{
			0:{
				items:2
			},
			600:{
				items:3
			},
			1000:{
				items:6
			}
		}
	});

	$('.produtos-carrosel').owlCarousel({
		loop:false,
		margin:30,
		autoplay:false,
		autoplayTimeout:6000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

	$('.depoimentos-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:1
			},
			1000:{
				items:2
			}
		}
	});

	//FIX HEADER
	window.onscroll = function() { fixHeader() };
	function fixHeader() {
		if (window.pageYOffset > 70) {
			$('#topo').addClass('scrooled');
		} else {
			$('#topo').removeClass('scrooled');
		}
	}

	$('a.sem-link').click(function(e) {
		e.preventDefault();
	});

});